// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"320759a7","204":"16b0012f"}[chunkId] + ".chunk.js";
};